import { Flex } from "@chakra-ui/react";
import { IoIosArrowRoundDown } from "react-icons/io";
import { FormattedMessage } from "react-intl";

import { RanaAlert, RanaButton } from "@nens/ranalib";

import { modelIsBeingGenerated } from "@/utils/model-is-being-generated";
import { scrollToElementAndFlash } from "@/utils/scroll-to-element-and-flash";

import { MODEL_TASK_TABLE_ID } from "../consts/model-task-table-id";
import { useSchematisationDetailsContext } from "../schematisation-details-context";

export function SchematisationValidityAlerts() {
  const { revision, threediModel } = useSchematisationDetailsContext();

  return (
    <>
      {revision.isValid === false && (
        <RanaAlert status="warning">
          <FormattedMessage
            id="file.schematisation_invalid"
            defaultMessage="This model schematisation's revision is invalid"
          />
        </RanaAlert>
      )}
      {revision.isValid == null && (
        <RanaAlert status="info">
          <FormattedMessage
            id="file.schematisation_being_checked"
            defaultMessage="This revision's validity is being checked"
          />
        </RanaAlert>
      )}
      {modelIsBeingGenerated(threediModel) && (
        <RanaAlert status="info">
          <Flex w="full" gap={4} alignItems="center" justifyContent="space-between">
            <FormattedMessage
              id="file.model.being_generated"
              defaultMessage="A Rana model of this revision is being generated"
            />
            <RanaButton
              onClick={() => {
                const element = document.getElementById(MODEL_TASK_TABLE_ID);
                if (element) {
                  scrollToElementAndFlash(element);
                }
              }}
              variant="fourthiary"
              rightIcon={<IoIosArrowRoundDown />}
            >
              <FormattedMessage id="file.model.go_to_tasks" defaultMessage="Go to model tasks" />
            </RanaButton>
          </Flex>
        </RanaAlert>
      )}
    </>
  );
}
